module.exports = __webpack_public_path__ + "static/media/softether.271b46c4.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/softether.ico
// module id = 193
// module chunks = 0